import _ from 'lodash';
import config from 'client/shared/config';
import { toast } from 'react-toastify';

import {
	observable,
	action,
	computed,
	runInAction
} from 'mobx';

import BaseStore from './base-store';
import Label from './label';

const { routes } = config;

class LabelStore extends BaseStore {
	apiRoute = routes.labels;

	/**
	 * Observables & Computeds
	 */

	@computed
	get labels () {
		return this._items;
	}

	set labels (labels) {
		this._items = labels;
	}

	@computed
	get labelsByUpdated () {
		return _(this.labels).sortBy('updatedAt').value();
	}

	@computed
	get labelsByCreated () {
		return _(this.labels).sortBy('createdAt').value();
	}

	/**
	 * Actions
	 */

	@action
	onFetchSuccess (data) {
		this._items = data.map((label) => new Label(this, label));
	}

	@action
	newLabel (data = {}) {
		const label = new Label(this, data);
		this.labels.unshift(label);

		return label;
	}

	@action
	async saveLabel (label, opts = {}) {
		this.isLoading = opts.silent !== true;

		try {

			const route = _.isEmpty(label.id) ? routes.labelCreate : this.apiRoute;
			await this.save(label, { route });
			toast.success('Label saved!');
		} catch (err) {

			toast.error('Error saving label!');
			throw err;
		} finally {

			this.isLoading = false;
		}
	}

	@action
	deleteLabel (label) {
		this.delete(label);
		toast.success('Label deleted!');
	}
}

const labelStore = new LabelStore();

window.labelStore = labelStore;

export default labelStore;
